export const API_BASE= 'http://api.fitness.outsourcingnepal.com/api';
export const API_TOKEN = 'eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJodHRwOi8vc2NoZW1hcy54bWxzb2FwLm9yZy93cy8yMDA1LzA1L2lkZW50aXR5L2NsYWltcy9uYW1lIjoic3VwZXJhZG1pbiIsImp0aSI6IjcxMzJiOGMwLTNhMDUtNDE5ZC1iZDZmLTI5NDRkN2MyYjM4NiIsImh0dHA6Ly9zY2hlbWFzLm1pY3Jvc29mdC5jb20vd3MvMjAwOC8wNi9pZGVudGl0eS9jbGFpbXMvcm9sZSI6IlN1cGVyQWRtaW4iLCJleHAiOjE2OTY3NDg5NzEsImlzcyI6Imh0dHA6Ly9sb2NhbGhvc3Q6NTAwMCIsImF1ZCI6Imh0dHA6Ly9sb2NhbGhvc3Q6NDIwMCJ9.yTb82mz7ccNhyApffvw6y6VAkVfYB30_MbI4cvL9Sdo';



export const API_BASE1='https://posv1api.essencetechnologies.com/api';

export const API_BASE2='https://posv1api.essencetechnologies.com/api';

export const API_BASE3='https://api.oneworldcourier.sebs.asia/api';